import * as ss from 'superstruct';

export const Id = ss.integer();
